import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            const next = location.state?.from || "/dashboard";
            toast.success("Welcome back.");
            navigate(next);
        } catch (err) {
            toast.error(err.response?.data?.detail || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 py-12" data-testid="login-page">
            <div className="surface p-8 w-full max-w-md">
                <div className="flex items-center gap-2 mb-6">
                    <Sparkles className="w-4 h-4 text-accent" />
                    <span className="overline !text-zinc-400">Welcome back</span>
                </div>
                <h1 className="font-heading text-3xl font-bold tracking-tight mb-1">Sign in</h1>
                <p className="text-sm text-zinc-500 mb-8">Continue building listings.</p>

                <form onSubmit={submit} method="post" className="space-y-5" autoComplete="on">
                    <div>
                        <label htmlFor="login-email" className="block text-xs font-medium text-zinc-400 mb-2">Email</label>
                        <input
                            id="login-email"
                            name="email"
                            type="email"
                            autoComplete="username"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="surface-input"
                            data-testid="login-email"
                            placeholder="seller@store.com"
                        />
                    </div>
                    <div>
                        <div className="flex items-baseline justify-between mb-2">
                            <label htmlFor="login-password" className="block text-xs font-medium text-zinc-400">Password</label>
                            <Link to="/forgot-password" className="text-xs text-accent hover:underline" data-testid="login-forgot-link">
                                Forgot password?
                            </Link>
                        </div>
                        <input
                            id="login-password"
                            name="password"
                            type="password"
                            autoComplete="current-password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="surface-input"
                            data-testid="login-password"
                            placeholder="••••••••"
                        />
                    </div>
                    <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="login-submit">
                        {loading ? "Signing in..." : "Sign in"}
                    </button>
                </form>
                <p className="mt-6 text-sm text-zinc-500">
                    No account? <Link to="/register" className="text-accent hover:underline" data-testid="login-register-link">Create one</Link>
                </p>
            </div>
        </div>
    );
}
